"use strict";
var Observable_1 = require("../../Observable");
var do_1 = require("../../operator/do");
Observable_1.Observable.prototype.do = do_1._do;
Observable_1.Observable.prototype._do = do_1._do;
//# sourceMappingURL=do.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/do.js
 ** module id = 297
 ** module chunks = 1
 **/